<template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <router-link
            class="title"
            :to="{name: 'UserList'}"
          >
            Users
          </router-link>
        </div>
      </div>
    </section>

    <UsersList />
  </div>
</template>

<script>
  import UsersList from '@/components/users/UsersList.vue'

  export default {
    name: 'Users',
    components: {
      UsersList
    },
    data () {
      return {

      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
